<!-- truncate-options keeps the dropdown the width of the select; long options wrap instead -->
<ng-select
  #select
  class="truncate-options"
  [placeholder]="placeholder"
  [labelForId]="labelForId"
  [items]="offices$ | async"
  [typeahead]="searchInput$"
  [loading]="loading"
  [ngModel]="office"
  (ngModelChange)="onChange($event)">

  <ng-template ng-label-tmp let-office="item" let-clear="clear">
    <span class="ng-value-icon left" (click)="clear(office)" aria-hidden="true">×</span>
    <span class="ng-value-label">
      F: {{ office.fax | phoneNumber }}
      @if (office.name) {
        | {{ office.name }}
      }
    </span>
  </ng-template>

  <ng-template ng-option-tmp let-office="item">
    F: {{ office.fax | phoneNumber }} |
    @if (office.name) {
      {{ office.name }} |
    }
    {{ office.address1 }},
    @if (office.address2) {
      {{ office.address2 }},
    }
    {{ office.city }}, {{ office.state }} {{ office.zip }}
  </ng-template>

  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    @if (searchTerm.length < minFaxLength) {
      <div class="ng-option ng-option-disabled">Enter at least {{ minFaxLength }} digits</div>
    } @else {
      <div class="ng-option">
        No results found -
        <a href="/capture-admin/offices/all?new={{ searchTerm }}" target="_blank" (click)="select.close()">
          Add a New Office
        </a>
      </div>
    }
  </ng-template>
</ng-select>
